import React from "react";

import styled from "styled-components";
import { space, SpaceProps, layout, LayoutProps, display } from "styled-system";

interface StyledProps extends SpaceProps, LayoutProps {
  children?: React.ReactNode;
}


interface BinProps extends StyledProps {
  color?: string;
}

const StyledContainer = styled.div<StyledProps>`
  display: flex;
  ${display}
  ${space}
  ${layout}
`;

const ChangeOfRegistrationSVG: React.FunctionComponent<BinProps> = ({
  ...rest
}) => {
  return (
    <StyledContainer {...rest}>
      <svg width="24" height="24" fill="none" viewBox="0 0 24 24">
        <path
          fill="#070B16"
          d="M6.633 6.867C6.633 5.836 7.47 5 8.5 5h1.867v14H8.5a1.867 1.867 0 01-1.867-1.867V6.867z"
        />
        <path
          fill="#fff"
          d="M10.867 5.5H15.5c.755 0 1.367.612 1.367 1.367v10.266c0 .755-.612 1.367-1.367 1.367h-4.633v-13z"
        />
        <path
          stroke="#000"
          d="M10.867 5.5H15.5c.755 0 1.367.612 1.367 1.367v10.266c0 .755-.612 1.367-1.367 1.367h-4.633v-13z"
        />
      </svg>
    </StyledContainer>
  );
};

export default ChangeOfRegistrationSVG;
